import { render, staticRenderFns } from "./DialogChangeTransferStatusDriver.vue?vue&type=template&id=04c00b2d&"
import script from "./DialogChangeTransferStatusDriver.vue?vue&type=script&lang=js&"
export * from "./DialogChangeTransferStatusDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04c00b2d')) {
      api.createRecord('04c00b2d', component.options)
    } else {
      api.reload('04c00b2d', component.options)
    }
    module.hot.accept("./DialogChangeTransferStatusDriver.vue?vue&type=template&id=04c00b2d&", function () {
      api.rerender('04c00b2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogChangeTransferStatusDriver.vue"
export default component.exports